import React, { useState } from "react";
import ProjectTopSlider from "../top/ProjectTopSlider";
import PageTitle from "../../common/PageTitle";
import { SonicProjectData } from "../../common/classes/SonicProject";
import styles from "./ProjectPage.module.scss";
import ProjectEmptyState from "./ProjectEmptyState";
import PageHelperModal from "../../common/page-help/PageHelperModal";
import SonicLink from "../../common/routing/SonicLink";

type Props = {
  // pickupProject: Array<SonicProjectData>;
  newProject: Array<SonicProjectData>;
  endProject: Array<SonicProjectData>;
  tryoutProject: Array<SonicProjectData>;
  auditionProject: Array<SonicProjectData>;
  isLoading: boolean;
  showEmptyState: boolean;
};

const ProjectTop: React.FC<Props> = ({
  newProject,
  endProject,
  tryoutProject,
  auditionProject,
  isLoading,
  showEmptyState,
}) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const handleHelpModal = () => {
    setShowModal(!showModal);
  };
  return (
    <div className={styles["p-project"]}>
      <PageTitle
        title="PROJECTS"
        subtext="プロジェクト"
        handleHelpModal={handleHelpModal}
      />
      <div className={styles["p-project__container"]}>
        {/*
        <div className={styles["p-project__empty-state"]}>
          <h3 className={styles["p-project__empty-state__ttl-orange"]}>
            プロジェクト機能<br></br>10/7(木) リリース予定!!
          </h3>
          <img
            src={ProjectInfo}
            className={styles["p-project__empty-state__img"]}
          />
          <p className={styles["p-project__empty-state__text"]}>
            企画、イベントのメンバー募集や応募ができる、「プロジェクト機能」が10/7(木)にリリース予定です。
            <br></br>
            応募後のユーザー間のやりとりはSELeCTがサポートするので安心。
            <br></br>
            登録ユーザー全員がプロジェクトを作成できるので、自身で企画や募集を掲載することもできます。
          </p>
          <h3 className={styles["p-project__empty-state__ttl-orange"]}>
            プロジェクト事前登録受付中!!
          </h3>
          <p className={styles["p-project__empty-state__text"]}>
            プロジェクト機能公開に先駆けて、ただいまプロジェクトの事前申請を受け付けています。
            <br></br>
            事前登録いただいたプロジェクトは、もれなくSELeCT公式X(旧Twitter)で宣伝させていただきます。
            <br></br>
            会員の方であれば、どなたでもプロジェクトを作成できるので、ぜひお試しください。
            <br></br>
            プロジェクトの事前申請は、【マイページ →
            プロジェクト設定】からご利用可能です。
          </p>
          <div className={styles["p-project__empty-state__tips"]}>
            <h4 className={styles["p-project__empty-state__tips-ttl"]}>
              こんな時にプロジェクト機能が便利
            </h4>
            <ul className={styles["p-project__empty-state__tips-list"]}>
              <li>
                <FontAwesomeIcon icon={["fal", "check-circle"]} />
                チームメンバーを探している
              </li>
              <li>
                <FontAwesomeIcon icon={["fal", "check-circle"]} />
                スポンサーを探している
              </li>
              <li>
                <FontAwesomeIcon icon={["fal", "check-circle"]} />
                イベントスタッフ・お手伝いさんを募集している
              </li>
            </ul>
          </div>
          <div className={styles["p-project__empty-state__link-wrapper"]}>
            <SonicLink
              to="/mypage"
              className={styles["p-project__empty-state__link"]}
            >
              マイページへ
            </SonicLink>
          </div>
        </div> */}
        {showEmptyState ? (
          <ProjectEmptyState />
        ) : (
          <>
            {/* TODO Displayed after implementing the function of
            selecting Featured Projects in the administration screen. */}
            {/* {pickupProject.length !== 0 && (
              <ProjectTopSlider
                highlight="イチオシ"
                title="プロジェクト"
                category="featured"
                projects={pickupProject}
              />
            )} */}
            <ProjectTopSlider
              title="新着プロジェクト"
              showScrollHeader={false}
              search="?sort=_id"
              projects={newProject}
              category="new"
              isLoading={isLoading}
            />
            <ProjectTopSlider
              title="終了日が近いプロジェクト"
              showScrollHeader={false}
              search="?sort=end_date"
              projects={endProject}
              category="end_date"
              isLoading={isLoading}
            />
            {tryoutProject.length !== 0 ? (
              <ProjectTopSlider
                title="トライアウト"
                showScrollHeader={false}
                search="?category=tryout"
                projects={tryoutProject}
                category="tryout"
                isLoading={isLoading}
              />
            ) : null}
            {auditionProject.length !== 0 ? (
              <ProjectTopSlider
                title="オーディション"
                showScrollHeader={false}
                search="?category=audition"
                projects={auditionProject}
                category="audition"
                isLoading={isLoading}
              />
            ) : null}
          </>
        )}
        <div className={styles["p-project__finished-project"]}>
          <SonicLink to="/project/list/?page_type=finished">
            終了したプロジェクトはこちら
          </SonicLink>
        </div>
      </div>
      {showModal === true ? (
        <PageHelperModal
          handleHelpModal={handleHelpModal}
          helpTitle="プロジェクトとは？"
          helpText={
            "SELeCT会員のプロジェクトが掲載されています。\nプロジェクトへの協力者や参加者を募集できます。"
          }
        />
      ) : null}
    </div>
  );
};

export default ProjectTop;
